import { Ref, Prop, Component } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class WishlistButton extends ThemeComponent {

    @Prop product!: ShopifyProduct;
    @Prop selected!: number;
    @Prop quantity!: number;
    @Prop strings!: Translations;

    @Ref() button!: HTMLButtonElement;
    @Ref() buttonText!: HTMLSpanElement;

    init() {

        document.addEventListener('swym-loaded', () => {
            this.updateInitialState();
        });

        this.$listen(this.button, 'click', () => {
            this.handleWishlist();
        });
    }

    /**
     * Ensure when the component loads the state of
     * the button is accurate
     */
    updateInitialState() {

        /* eslint-disable */
        if (!window._swat) { return; }
        const productId = this.product.id;

        window._swat.fetch((items: {[key: string]: string}[]) => {
            for (const item of items) {
                if (~~productId === ~~item.empi) {
                    this.classList.add('is-active');
                    this.buttonText.innerText = this.strings.added_to_wishlist;
                }
            }
        });
        /* eslint-enable */
    }

    handleWishlist() {
        if (this.classList.contains('is-active')) {
            this.removeFromWishlist();
        } else {
            this.addToWishlist();
        }
    }

    /**
     * Add to wishlist.
     * @returns
     */
    addToWishlist() {

        /* eslint-disable */
        if (!window._swat) { return; }
        const variantId = Number(this.selected);
        const productId = this.product.id;
        const productUrl = this.product.url;
        const image = this.product.featuredImage;
        const quantity = this.quantity;
        const variants = this.product.variants;

        window._swat.addToWishList(
            {
                epi: variantId,
                du: productUrl,
                empi: productId,
                iu : image,
                pr: this.product.price,
                stk: quantity,
                et: 4,
                variants: variants
            },
            () => {
                this.classList.add('is-active');
                this.buttonText.innerText = this.strings.added_to_wishlist;
                document.dispatchEvent(new Event('wishlistUpdated'));
            }
        );
        /* eslint-enable */
    }

    /**
     * Remove from wishlist.
     * @returns
     */
    removeFromWishlist() {

        /* eslint-disable */
        if (!window._swat) { return; }
        const variantId = Number(this.selected);
        const productId = this.product.id;
        const productUrl = this.product.url;
        const image = this.product.featuredImage;
        const quantity = this.quantity;
        const variants = this.product.variants;


        window._swat.removeFromWishList(
            {
                epi: variantId,
                du: productUrl,
                empi: productId,
                iu: image,
                pr: this.product.price,
                stk: quantity,
                variants: variants
            },
            () => {
                this.classList.remove('is-active');
                this.buttonText.innerText = this.strings.add_to_wishlist;
                document.dispatchEvent(new Event('wishlistUpdated'));
            }
        );
        /* eslint-enable */
    }
}
